import React, { useRef, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Swiper, SwiperSlide } from "swiper/react";
import axios from "axios";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";

import axiosInstance, { weburl } from "../../axiosInstance";

// import required modules
import { Pagination, Navigation, Autoplay } from "swiper/modules";

import banner1 from "../assets_user/img/fullbanner1.webp";
import banner2 from "../assets_user/img/fullbanner2.webp";
import banner3 from "../assets_user/img/fullbanner3.webp";
import banner4 from "../assets_user/img/fullbanner4.webp";

import grid1 from "../assets_user/img/grid1.webp";
import grid2 from "../assets_user/img/grid2.webp";
import grid3 from "../assets_user/img/grid3.webp";
import grid4 from "../assets_user/img/grid4.webp";
import gridslide1 from "../assets_user/img/gridslide1.webp";
import gridslide2 from "../assets_user/img/gridslide2.webp";
import gridslide3 from "../assets_user/img/gridslide3.webp";
import gridslide4 from "../assets_user/img/gridslide4.webp";
import gridslide5 from "../assets_user/img/gridslide5.webp";
import CreateSlug from "../components/extra/CreateSlug";
import { useBlogContext } from "../../fetchdata/BlogContext";
import LoadingHomeScreen from "../components/LoadingHomeScreen";
import GooglePlaceSelect from "../components/extra/GooglePlaceSelect";

const Home = () => {


const [captchaAnswer, setCaptchaAnswer] = useState("");
const [captchaQuestion, setCaptchaQuestion] = useState("");
const [captchaResult, setCaptchaResult] = useState(null);
const [captcha, setCaptcha] = useState("");
const [generatedCaptcha, setGeneratedCaptcha] = useState("");

 useEffect(() => {
  generateCaptcha();
}, []);

const generateCaptcha = () => {
  const num1 = Math.floor(Math.random() * 10);
  const num2 = Math.floor(Math.random() * 10);

  const isAddition = Math.random() > 0.5;

  if (isAddition) {
    setCaptchaQuestion(`${num1} + ${num2}`);
    setCaptchaResult(num1 + num2);
  } else {
    // Ensure no negative result
    const max = Math.max(num1, num2);
    const min = Math.min(num1, num2);
    setCaptchaQuestion(`${max} - ${min}`);
    setCaptchaResult(max - min);
  }
};

 
const validateForm = () => {
  
  if (!formData.name) return "Name is required";
  if (!formData.phone) return "Phone is required";
  if (formData.phone.length !== 10) return "Phone must be 10 digits";
  if (!filterInputs.placeId) return "Location is required";
  if (Number(captchaAnswer) !== captchaResult) {
    return "Wrong captcha answer";
  }

  return null;
};

    const initialFilterData = {};
    
  
    const [filterInputs, setFilterInputs] = useState(initialFilterData);
  
  
  const handleLocationChange = (selected) => {
    console.log('myselected',selected)
    setFilterInputs({
      location: selected?.label || "",
      placeId: selected?.value || "",
      state: selected?.state || "",
      city: selected?.city || "",
      label: selected?.label || "",
      lat: selected?.lat || "",
      lng: selected?.lng || "",
    });
  };
  
  
  
   const [filter, setFilter] = useState(false);


   
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = e => {
    const { name, value } = e.target;
    const normalizedValue =
      name === "phone" ? value.replace(/\D/g, "").slice(0, 10) : value;

    setFormData({ ...formData, [name]: normalizedValue });
  };

  const handleSubmit = async () => {

      const error = validateForm();
  if (error) {
    toast.error(error);
    return;
  }

  const payload = {
    ...formData,
    location: filterInputs.location,
    placeId: filterInputs.placeId,
    city: filterInputs.city,
    state: filterInputs.state,
    lat: filterInputs.lat,
    lng: filterInputs.lng,
  };

     try {
      await axiosInstance.post('/contact-enquire', payload);
      toast.success('Email sent successfully');
      setFormData({ name: '', email: '', phone: '', message: '' });
      setFilterInputs({});
      setCaptchaAnswer("");
      generateCaptcha();
    } catch (error) {
      console.error('Failed to send email:', error);
      toast.error('Failed to send email');
    }
  };



  const pastelColors = [
  "#FBE7C6", // pastel peach
  "#E7FBBE", // pastel green
  "#D8EAFF", // pastel blue
  "#FFD8E8", // pastel pink
  "#F3E8FF", // pastel lavender
  "#FFF4D9", // pastel yellow
  "#E8FFF5"  // pastel mint
];

const getRandomPastel = () => {
  const r = Math.floor((Math.random() * 127) + 127); 
  const g = Math.floor((Math.random() * 127) + 127); 
  const b = Math.floor((Math.random() * 127) + 127); 
  return `rgb(${r}, ${g}, ${b})`;
};

  const {
    Headers,
    isHeader,
    cartItems,
    AllProducts,
    AllCategoriess,
    isLayoutLoading,
    layout,
  } = useBlogContext();

  const swiperRefLocal = useRef();

  const handleMouseEnter = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.stop();
  };

  const handleMouseLeave = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.start();
  };

  const [ratings, setRatings] = useState([]);

  const [isProducts, setIsProducts] = useState(true);

  const [Products, setProducts] = useState([]);

  const [blogs, setBlogs] = useState([]);

  const [isBlogsLoading, setIsBlogsLoading] = useState(true);

  const getRating = async () => {
    try {
      const { data } = await axiosInstance.get(`/all-rating`);
      setRatings(data.ratings);
      console.log("getRating", data);
    } catch (error) {
      console.error("Error fetching rating:", error);
    }
  };

  const getBlogs = async () => {
    setIsBlogsLoading(true);
    try {
      const { data } = await axiosInstance.get('/all-blogs?limit=4&page=1');
      setBlogs(data.blogs || []);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setIsBlogsLoading(false);
    }
  };

  useEffect(() => {
    getRating();
    getBlogs();
  }, []);

  const getProducts = async () => {
    try {
      const { data } = await axiosInstance.get("/all-home-products");
      console.log("products", data);
      setProducts(data.products);
      setIsProducts(false); // Set loading state to false in case of an error
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsProducts(false); // Set loading state to false in case of an error
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  const defaultWhyTrustSection = {
    heading: "Why Trust YNB Dental",
    leftImage: "/assets/img/dental-image.webp",
    leftTitle: "Trusted Care. Skilled Doctors.",
    leftDescription:
      "Advanced dentistry with patient-first approach and modern technology.",
    badges: ["Sterile", "Doctor Led", "Modern Tech"],
    cards: [
      {
        icon: "🌍",
        title: "Modern Dental Treatment",
        subtitle: "Trusted standards that improve your experience",
        point1: "Advanced dental equipment",
        point2: "Premium quality materials",
        point3: "Comfortable & painless procedures",
      },
      {
        icon: "👨‍⚕️",
        title: "Doctor-Led Patient Care",
        subtitle: "Trusted standards that improve your experience",
        point1: "One-to-one consultation",
        point2: "Clear treatment explanation",
        point3: "Personalized care approach",
      },
      {
        icon: "⭐",
        title: "Growing Experience",
        subtitle: "Trusted standards that improve your experience",
        point1: "Dedicated and skilled dental team",
        point2: "Focus on quality treatment",
        point3: "Every patient handled with care",
      },
      {
        icon: "🛡️",
        title: "High Safety Standards",
        subtitle: "Trusted standards that improve your experience",
        point1: "Strict sterilization protocols",
        point2: "Clean and hygienic clinic",
        point3: "Safe and secure environment",
      },
      {
        icon: "🧩",
        title: "Personalized Treatment Planning",
        subtitle: "Trusted standards that improve your experience",
        point1: "Tailored treatment options",
        point2: "Patient-first approach",
        point3: "Detailed dental assessment",
      },
      {
        icon: "💰",
        title: "Transparent & Honest Pricing",
        subtitle: "Trusted standards that improve your experience",
        point1: "No hidden charges",
        point2: "Clear communication",
        point3: "Affordable treatment options",
      },
    ],
  };

  const whyTrustSection = {
    ...defaultWhyTrustSection,
    ...(layout?.why_trust_section || {}),
    badges:
      layout?.why_trust_section?.badges?.length > 0
        ? layout.why_trust_section.badges
        : defaultWhyTrustSection.badges,
    cards:
      layout?.why_trust_section?.cards?.length > 0
        ? layout.why_trust_section.cards
        : defaultWhyTrustSection.cards,
  };

  return (
    <>
      <Header />

      <Helmet>
        {Headers && Headers.meta_favicon && (
          <link rel="apple-touch-icon" href={Headers.meta_favicon} />
        )}
        {Headers && Headers.meta_title && (
          <>
            <title>{Headers.meta_title}</title>
            {Headers.meta_description && (
              <meta name="description" content={Headers.meta_description} />
            )}
          </>
        )}
      </Helmet>



            <main className="page">

              {isLayoutLoading ? 
               <LoadingHomeScreen/>  : 
              <>

   <div className=" bg-light">
 
   {/* HERO (PDF Page 1 top banner) */}
  <section className="container py-4 ">
    

{layout.home_slider.length !== 0 ? 
<>

        {/* Hero Section */}
        <div
                className="hero hero-swiper z-0"
                style={{
                  width: 1400,
                  maxWidth: "100% ",
                  height: "auto",
                  aspectRatio: "1400/400",
                  borderRadius: 15,
                  overflow: "hidden",
                }}
              >
                {isLayoutLoading ? (
                  <>
                    <div
                      className="skeleton w-100"
                      style={{
                        width: 1500,
                        maxWidth: "100% ",
                        height: "auto",
                        aspectRatio: "1400/400",
                      }}
                    ></div>
                  </>
                ) : (
                  <div
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <Swiper
                      pagination={true}
                      navigation={true}
                      gap={"30"}
                      ref={swiperRefLocal}
                      autoplay={{
                        delay: 1500,
                        pauseOnMouseEnter: true,
                      }}
                      loop={true}
                      modules={[Pagination, Navigation, Autoplay]}
                      className="swiper-wrapper"
                      style={{
                        width: 1400,
                        maxWidth: "100% ",
                        height: "auto",
                        aspectRatio: "1400/400",
                        borderRadius: 15,
                        overflow: "hidden",
                      }}
                    >
                      {layout.home_slider && (
                        <>
                          {layout.home_slider.map((image, index) => (
                            <SwiperSlide key={index}>
                              <img
                                className="img-fluid w-100"
                                src={image}
                                alt="YNB Healthcare Services"
                              />
                            </SwiperSlide>
                          ))}
                        </>
                      )}
                    </Swiper>
                  </div>
                )}
              </div>
        {/* Hero Section */}
        </>
: 
<>

    <div className="hero-wrap border border-white border-3 shadow p-4 p-lg-0 " style={{backgroundImage:`url('${layout.slider_img}')`,backgroundSize:'cover'}}>
      <div className="row align-items-center g-4 mt-50 mb-50">
        <div className="col-lg-8">
            <div className='p-lg-4 ms-lg-5 text-white'>
           
          <div className="d-flex align-items-center gap-2 mb-3 ">
            <div className="fw-bold fs-4 ">YNB DENTAL </div>
            {/* <div className="opacity-75">|</div>
            <div className="opacity-75 fw-semibold">Dentist</div> */}
          </div>
          <h1 className="fw-bold lh-sm mb-3 text-white">
        Crafting Healthy Smiles with <br/> Care and Precision
          </h1>
          <div className="d-flex flex-wrap gap-4 mb-4">
            <div className="d-flex align-items-center gap-2">
              <span className="small-icon">✓</span>
              <span className="small">Modern Dentistry</span>
            </div>
            <div className="d-flex align-items-center gap-2">
              <span className="small-icon">✓</span>
              <span className="small">  Gentle & Painless Care </span>
            </div>
            <div className="d-flex align-items-center gap-2">
              <span className="small-icon">✓</span>
              <span className="small"> Patient-First Approach  </span>
            </div>
          </div>
          <Link to="/all-doctor" className="btn btn-danger mt-4   px-4">
            Book Appointment <i className="ri-arrow-right-line ms-2"></i>
          </Link>
        </div>
        </div>

        <div className="col-lg-4">
          {/* Replace with your model image */}
          {/* <div className=" w-100 d-flex align-items-center justify-content-center">
            
             <img src={layout.slider_img} className='w-100'/>
          </div> */}
        </div>
             
            
      </div>
    </div>

    </>
}

    
    {/* STATS STRIP – Enhanced UI */}
<div
  className="container mt-4 px-0 mb-4 d-none"
>
  <div
    className="row text-center g-0 rounded-4 shadow-sm bg-white border py-3"
  >

    {/* Item */}
    <div className="col-6 col-md border-end">
      <div className="d-flex flex-column align-items-center gap-1">
        <div className="fw-bold fs-5 text-dark">30L+</div>
        <div className="small text-muted">Happy Patients</div>
      </div>
    </div>

    <div className="col-6 col-md border-end">
      <div className="d-flex flex-column align-items-center gap-1">
        <div className="fw-bold fs-5 text-dark">1300+</div>
        <div className="small text-muted">Expert Dentists</div>
      </div>
    </div>

    <div className="col-6 col-md border-end">
      <div className="d-flex flex-column align-items-center gap-1">
        <div className="fw-bold fs-5 text-dark">600+</div>
        <div className="small text-muted">Clinics</div>
      </div>
    </div>

    <div className="col-6 col-md border-end">
      <div className="d-flex flex-column align-items-center gap-1">
        <div className="fw-bold fs-5 text-dark">7 Days</div>
        <div className="small text-muted">Open</div>
      </div>
    </div>

    <div className="col-6 col-md border-end">
      <div className="d-flex flex-column align-items-center gap-1">
        <div className="fw-bold fs-5 text-dark">55K+</div>
        <div className="small text-muted">Implants Done</div>
      </div>
    </div>

    <div className="col-6 col-md border-end">
      <div className="d-flex flex-column align-items-center gap-1">
        <div className="fw-bold fs-5 text-dark">7.8K+</div>
        <div className="small text-muted">Dentures</div>
      </div>
    </div>

    <div className="col-6 col-md">
      <div className="d-flex flex-column align-items-center gap-1">
        <div className="fw-bold fs-5 text-dark">2L+</div>
        <div className="small text-muted">Crowns Placed</div>
      </div>
    </div>

  </div>
</div>


  </section>

   </div>


    {/* MISS UNIVERSE SLIDER (PDF Page 1) */}
  <section className="container py-5 mb-50 ">
    <div className="d-flex align-items-center justify-content-between mb-4 pb-4">
      <h4 className="fw-bold mb-0 h3 text-primary">Discover Our Smile Transformation Work</h4>
     
    </div>
    <div className="row g-3">
   
  {layout?.latest_product_banner?.map((item, index) => (
      <Link className="col-6 col-md-3"  to={item.imageUrlInput} key={index} >
    <div className="video-card">
      <div className="video-thumb position-relative">
        {/* <div className="play"><i className="ri-play-large-fill" /></div> */}
        <img
          src={item.imageInput}
          alt={item.imageTITInput}
          className="w-100 position-absolute h-100 object-fit-cover"
        />
      </div>
      <div className="p-3 z-1 bg-primary">
        <div className="small fw-bold text-uppercase text-white"> {item.imageTITInput} </div>
        <div className="small text-muted2 "> {item.imageParaInput} </div>
        {/* <button className="btn btn-danger btn-sm mt-2 px-4 rounded-pill" > <i className="ri-play-large-fill"/> Watch Now </button> */}
      </div>
    </div>
  </Link>

   
  ))}
 
</div>

  </section>


  {/* HOW CAN WE HELP (8 tiles) (PDF Page 1) */}
  <section className="bg-light pb-50 pt-50">
    <div className="container">
      <div className="text-center mb-4">
        <h3 className="fw-bold mb-1 text-primary">How can we assist with your dental care today?</h3>
        <div className="small text-muted2 mb-4">
         Please select the option that best describes your need, then click Continue.
        </div>
      </div>
      <div className="row g-3 justify-content-center"> 

        
         {layout?.trending_product_banner?.map((item, i) => (
    <Link className="col-6 col-md-2 " key={i} to={item.imageUrlInput}>
      <div className="tile p-3 text-center bg-white border border-primary">
        <div className="icon-chip mx-auto mb-2 p-2 bg-light border ">
          <img src={item.imageInput} width="50" alt={item.imageTITInput} />
        </div>
        <div className="small fw-semibold text-dark">{item.imageTITInput}</div>
      </div>
    </Link>
  ))}
        </div>
    </div>
  </section>

  {/* 3 INFO CARDS (Reviews + Clinics dropdown + Find Dentist) (PDF Page 1) */}
 
<section className="py-4 mt-50 mb-50 d-none ">
  <div className="container">

    {/* Heading */}
    <h2 className="text-center review-section-title mb-4 text-primary">
      Best Dental Hospital
    </h2>

    <div className="row align-items-center g-4">

      {/* Left Rating Box */}
      <div className="col-lg-3">
        <div className="rating-box border border-primary bg-light shadow-sm text-center">
          <div className="rating-label fs-4 mb-2 ">EXCELLENT</div>

          <div className="d-flex justify-content-center gap-1 mb-2">
            <span className="star">★</span>
            <span className="star">★</span>
            <span className="star">★</span>
            <span className="star">★</span>
            <span className="star">★</span>
          </div>

          <div className="text-muted mb-3">Based on <b>250 reviews</b></div>

          {/* Google text logo (simple) */}
          <div className="g-logo">
            <span style={{color:"#4285F4"}}>G</span>
            <span style={{color:"#EA4335"}}>o</span>
            <span style={{color:"#FBBC05"}}>o</span>
            <span style={{color:"#4285F4"}}>g</span>
            <span style={{color:"#34A853"}}>l</span>
            <span style={{color:"#EA4335"}}>e</span>
          </div>
        </div>
      </div>

      {/* Reviews + Arrows */}
      <div className="col-lg-9">
        <div className="position-relative">

          {/* Left Arrow */}
          {/* <button
            type="button"
            className="arrow-btn position-absolute top-50 start-0 translate-middle-y d-none d-md-inline-flex align-items-center justify-content-center"
            style={{ marginLeft: "-22px" }}
            aria-label="Previous"
          >
             <i className="ri-arrow-left-s-line"/> 
          </button> */}

          {/* Right Arrow */}
          {/* <button
            type="button"
            className="arrow-btn position-absolute top-50 end-0 translate-middle-y d-none d-md-inline-flex align-items-center justify-content-center"
            style={{ marginRight: "-22px" }}
            aria-label="Next"
          >
             <i className="ri-arrow-right-s-line"/> 
          </button> */}

          <div className="row g-4">
{
[
  {
    "name": "Gaurav Chaudhary",
    "time": "2 weeks ago",
    "rating": 5,
    "verified": true,
    "source": "Google",
    "avatar": "https://cdn-icons-png.flaticon.com/128/847/847969.png",
    "review": "YNB Dental is one of the best Dental clinic in Ghaziabad. I would recommend YNB Dental for all dental treatments."
  },
  {
    "name": "Ashok Kumar Rai",
    "time": "2 weeks ago",
    "rating": 5,
    "verified": true,
    "source": "Google",
    "avatar": "https://cdn-icons-png.flaticon.com/128/847/847969.png",
    "review": "Dr. Jesica is too much experienced doctor having good knowledge. Dental treatment of my father and wife has been excellent."
  },
  {
    "name": "Vipin Tyagi",
    "time": "2 weeks ago",
    "rating": 5,
    "verified": true,
    "source": "Google",
    "avatar": "https://cdn-icons-png.flaticon.com/128/847/847969.png",
    "review": "Thank you Dr. Jaisika Rajpal Arora for the care you provided during my recent treatment."
  }
].map((item, index) => (
    <div className="col-md-4" key={index}>
      <div className="review-card bg-white shadow-sm border  border-primary">
        <div className="d-flex align-items-start justify-content-between mb-2">
          <div className="d-flex align-items-center gap-3">
            <img className="avatar rounded-circle" src={item.avatar} alt="user" />
            <div>
              <div className="fw-bold text-uppercase">
                {item.name.length > 14
                  ? item.name.slice(0, 14) + "..."
                  : item.name}
              </div>
              <div className="text-muted small">{item.time}</div>
            </div>
          </div>

          <div className="google-badge">
            <div className="small fw-bold" title={item.source}>
              G
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center gap-2 mb-3">
          <div className="text-warning" style={{ fontSize: 18 }}>
            {"★".repeat(item.rating)}
          </div>
          {item.verified && (
            <span className="badge bg-primary-subtle text-primary rounded-pill">
              ✔
            </span>
          )}
        </div>

        <div className="mb-4">
          {item.review.length > 100
            ? item.review.slice(0, 100) + "..."
            : item.review}
        </div>

        <div className="btn btn-sm rounded-pill btn-danger text-white">Read more</div>
      </div>
    </div>
  ))} 
            

          </div>

         

        </div>
      </div>

    </div>
  </div>
</section>


<section className="py-5 bg-light">
  <div className="container">
    <div className="text-center mb-5">
      <h2 className="fw-bold">{whyTrustSection.heading}</h2>
    </div>
    <div className="row g-4">
      {/* Left Section */}
      <div className="col-lg-4">
        <div className="card h-100 shadow-sm border-0">
          <img
              src={whyTrustSection.leftImage}
              className="w-100 h-100 object-fit-cover"
              alt="Dental care"
              loading="lazy"
              style={{aspectRatio:'1/0.6'}}
            />
          <div className="card-body">
            <h4 className="fw-bold mb-3">{whyTrustSection.leftTitle}</h4>
            <p className="text-secondary mb-3">{whyTrustSection.leftDescription}</p>
            <div className="d-flex flex-wrap gap-2">
              {whyTrustSection.badges?.filter(Boolean).map((badge, index) => (
                <span className="badge text-bg-light border text-dark px-3 py-2" key={index}>
                  {badge}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Right Section */}
      <div className="col-lg-8">
        <div className="row g-3">
          {whyTrustSection.cards?.map((card, index) => (
            <div className="col-md-6" key={index}>
              <div className="card h-100 shadow-sm border-0">
                <div className="card-body">
                  <div className="d-flex align-items-start gap-3">
                    <div className="fs-3">{card.icon}</div>
                    <div>
                      <h5 className="fw-bold mb-1">{card.title}</h5>
                      <p className="text-secondary small mb-2">{card.subtitle}</p>
                      <ul className="mb-0">
                        {[card.point1, card.point2, card.point3].filter(Boolean).map((point, pointIndex) => (
                          <li key={pointIndex}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
</section>


  
 <section className="container py-4 d-none">
  <div className="appt-wrap p-3 p-lg-4 bg-primary">
    <div className="row align-items-center g-3">

      {/* Left Content */}
      <div className="col-lg-4">
        <div className="d-flex align-items-center gap-3 mb-2">
          {/* <div className="icon-circle "> <img src="https://cdn-icons-png.flaticon.com/128/5045/5045190.png" width={40} /> </div> */}
          <div>
            <div className="fw-bold fs-5 text-white">
              Book an Appointment
            </div>
            <div className="small text-muted2">
              Find a clinic near you in seconds
            </div>
          </div>
        </div>

        <div className="d-flex flex-wrap gap-2 mt-3">
          <span className="appt-pill small border bg-transparent text-white">✅ Same-day slots</span>
          <span className="appt-pill small border bg-transparent text-white">✅ Expert doctors</span>
          <span className="appt-pill small border bg-transparent text-white ">✅ Safe & hygienic</span>
        </div>
      </div>

      {/* Right Form */}
      <div className="col-lg-8">
        <div className=" rounded-4 p-3 ">
          <div className="row g-2 align-items-start">

            <div className="col-md-4">
              <div className="input-group border rounded">
                <span className="input-group-text bg-white border-0 pe-0">👤</span>
                <input className="form-control border-0 bg-white shadow-none" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required maxLength={20} />
              </div>
            </div>

            <div className="col-md-4">
              <div className="input-group border rounded" >
                <span className="input-group-text bg-white border-0 pe-0">📞</span>
                <input className="form-control border-0 bg-white shadow-none" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required maxLength={10} />
              </div>
            </div>

            <div className="col-md-4">
            <div className="d-flex align-items-center border px-2 rounded bg-white me-3 w-100  "   >
  <span className="px-1 pe-0" id="inputGroup-sizing-default">
    <i className="ri-map-pin-line" />
  </span>
  <GooglePlaceSelect
  value={
    filterInputs?.placeId
      ? {
          label: filterInputs?.location,
          value: filterInputs?.placeId,
          city: filterInputs?.city,
          state: filterInputs?.state,
          lat: filterInputs?.latitude,
          lng: filterInputs?.longitude,
        }
      : null
  }
   onChange={handleLocationChange}
/>
</div>

            </div>

        <div className="col-md-4">
  <div className="input-group border rounded">
    <span className="input-group-text bg-white border-0">🔒</span>
    <input
      type="number"
      className="form-control border-0 bg-white shadow-none"
      placeholder="Solve"
      value={captchaAnswer}
      onChange={(e) => setCaptchaAnswer(e.target.value)}
    />
  </div>
  <small className="text-white">
    Solve: {captchaQuestion} = ?
  </small>
</div>

            <div className="col-md-4">
              <button className="btn btn-danger w-100 rounded fw-semibold py-2" onClick={()=>handleSubmit()}>
                Book Now →
              </button>
            </div>

            <div className="col-md-4">
              <div className="small text-white text-center text-md-start">
                By booking, you agree to terms
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>


 {/* TREATMENTS GRID (PDF Page 2) */}

  {/* <section className="container pt-50  border-bottom pb-50">
    <div className="text-center mb-4">
      <h4 className="fw-bold text-primary">Dental Treatments </h4>
    </div>
 
 <div className="row g-3">
  {[
    "Root Canal Treatment",
    "Dental Crowns",
    "Laser Dentistry",
    "Clear Aligners",
    "Dental Fillings",
    "Wisdom Tooth",
    "Braces & Aligners",
    "Dental Implants",
    "Dentures",
    "Kids Dentistry",
    "Mouth Ulcers",
    "Gum Treatment",
  ].map((item, index) => (
    <div className="col-6 col-md-2  rounded" key={index}>
      <div className="tile p-3 text-center h-100 border border-primary">
        <div className="icon-chip mx-auto mb-2 p-2">
          <img
            src="https://cdn-icons-png.flaticon.com/128/1386/1386881.png"
            width="42"
            alt={item}
            loading="lazy"
          />
        </div>
        <div className="small fw-semibold ">{item}</div>
      </div>
    </div>
  ))}
</div>


  </section> */}

  {/* PATIENT SPEAKS (PDF Page 2) */}
  <div className='bg-light d-none' style={{ display: layout?.latest_product_carousal.length === 0 ? 'none': 'block' }}>
 
  <section className="container pb-50  pt-50 ">
    <div className="text-center mb-3">
      <h4 className="fw-bold mb-1 text-primary">Patient Speaks</h4>
      <div className="small text-muted2">
        Hear what our happy patients have to say
      </div>
    </div>
    <div className="row g-3">

      { layout.latest_product_carousal && layout.latest_product_carousal.map((item, index) => (
    <div className="col-6 col-md-2" key={index}>
      <div className="video-card position-relative border border-primary  bg-primary">
        <Link to={item.imageUrlInput} target="blank" className="video-thumb position-relative">
          <div className="play">
            <i className="ri-play-large-fill" />
          </div>
          <img
            src={item.imageInput}
            className="w-100 position-absolute h-100 object-fit-cover"
            alt={''}
          />
        </Link>

        <div className="p-2">
          <div className="small fw-bold text-white">{item.imageTITInput}</div>
         </div>
      </div>
    </div>
  ))} 
    
    </div>
    {/* <div className="text-center mt-3">
      <a
        className="btn btn-sm btn-danger rounded-pill"
        href="#" 
      >
        View More
      </a>
    </div> */}
  </section>
</div>
    {/* INDIA'S LARGEST TEAM (PDF Page 3) */}
   <section className="pt-50 pb-50">
  <div className="container">
    {/* Header */}
    <div className="text-center mb-5">
      <span className="badge bg-primary rounded-pill px-3 py-2 mb-3">
        {layout?.india_largest_team?.badge || "Dental Specialists Network"}
      </span>
      <h2 className="fw-bold mb-2 text-primary">
        {layout?.india_largest_team?.title || "India’s Most Trusted Network of Dental Specialists"}
      </h2>
      <p className="text-secondary mb-0">
        {layout?.india_largest_team?.subtitle || "Skilled. Certified. Compassionate."}
      </p>
    </div>

    {/* Stats */}
  <div className="row g-4 text-center mb-5">
  {(layout?.india_largest_team?.stats?.length > 0 ? layout.india_largest_team.stats : [
  {
    icon: "🦷",
    value: "75+",
    title: "Orthodontists",
    desc: "Expert teeth aligner care",
    bg: "rgba(13,110,253,.12)"
  },
  {
    icon: "👩‍⚕️",
    value: "70%",
    title: "Women Leading",
    desc: "Empathy, precision & excellence",
    bg: "rgba(25,135,84,.12)"
  },
  {
    icon: "🎓",
    value: "65%",
    title: "MDS Doctors",
    desc: "Advanced care across specialties",
    bg: "rgba(255,193,7,.18)"
  }
  ]).map((item, index) => (
    <div className="col-md-4" key={index}>
      <div className="card border border-primary  shadow-sm h-100">
        <div className="card-body d-flex p-4 justify-content-between gap-2 align-items-center">
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle "
            style={{ width: 54, height: 54, background: item.bg }}
          >
            {item.icon}
          </div>

<div>

          <div className="fw-semibold">{item.title}</div>
          <div className="small text-secondary">{item.desc}</div>
        </div>

          <div className="fs-4 fw-bold mb-1">{item.value}</div>


        </div>

      </div>
    </div>
  ))}
</div >
 

    {/* Doctors */}
    <div className="row g-4 d-none">
      {[
        { name: "Dr. Name", exp: "13+ Years", tag: "Orthodontist" },
        { name: "Dr. Name", exp: "41+ Years", tag: "Implant Specialist" },
        { name: "Dr. Name", exp: "23+ Years", tag: "Endodontist" },
        { name: "Dr. Name", exp: "20+ Years", tag: "Cosmetic Dentist" },
      ].map((d, i) => (
        <div className="col-6 col-lg-3" key={i}>
          <div className="card border border-primary shadow-sm h-100 overflow-hidden">
            {/* Image */}
            <div className="bg-light" style={{ height: 190 }}>
              {/* Replace with real image later */}
              <div className="w-100 h-100 d-flex align-items-center justify-content-center text-secondary">
                Doctor Photo
              </div>
            </div>

            <div className="card-body p-3">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="fw-bold">{d.name}</div>
                  <div className="small text-secondary">{d.exp} Experience</div>
                </div>
                <span className="badge text-bg-light border text-dark">{d.tag}</span>
              </div>

              <div className="d-grid mt-3">
                <button className="btn btn-primary btn-sm rounded-pill">
                  View Profile
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>

    {/* CTA */}
    <div className="text-center mt-5 d-none">
      <Link to="/all-doctor" className="btn btn-danger rounded-pill px-4 py-2">
        Meet Our Doctors
      </Link>
      <div className="small text-secondary mt-2">
        Verified specialists • Patient-first care • Modern clinics
      </div>
    </div>
  </div>
</section>


  {/* DENTAL HEALTH PLANS (2 cards) (PDF Page 3) */}
 <section className="bg-light pb-50 pt-50 d-none">
  <div className="container">

    {/* Heading */}
    <div className="text-center mb-5">
      <h3 className="fw-bold mb-2 text-primary">Dental Health All Products</h3>
      <p className="text-muted">
        Affordable dental care plans designed for every need
      </p>
    </div>

    <div className="row g-4 justify-content-center">

  {isProducts
    ? Array.from({ length: 4 }).map((_, i) => (
        <div className="col-lg-3 col-md-6" key={i}>
          <div
            className="plan-card p-4 border rounded skeleton"
            style={{ height: 320 }}
          ></div>
        </div>
      ))
    : Products.slice(0, 4).map((product, index) => {

        // ⭐ Rating Logic
        const productRatings = ratings.filter(
          (rating) => rating.productId === product._id
        );

        const totalRatings = productRatings.length;

        const averageRating =
          totalRatings > 0
            ? productRatings.reduce((acc, curr) => acc + curr.rating, 0) /
              totalRatings
            : 0;

        const myslug = CreateSlug(product.slug);

        return (
          <div className="col-lg-3 col-md-6" key={product._id}>
            <div className="plan-card border border-primary p-4 h-100 text-center position-relative">

              {/* 🔥 Badge */}
              {layout?.latest_product?.includes(product._id) && (
                <div className="plan-badge">Most Popular</div>
              )}

              {/* 🖼 Image */}
              <div className="mb-3">
                <img
                  src={product.pImage}
                  alt={product.title}
                  style={{
                    width: 70,
                    height: 70,
                    objectFit: "cover",
                    borderRadius: "50%",
                  }}
                />
              </div>

              {/* 🏷 Title */}
              <div className="fw-bold mb-1">{product.title}</div>

              {/* ⭐ Rating */}
              <span
                className={`star-rating star-${Math.round(averageRating) * 2}`}
              />

              {/* 💰 Price */}
              <div className="price mb-3">
                <span className="fw-bold text-danger">
                  ₹{product.salePrice}
                </span>{" "}
                <small className="text-muted">
                  <del>₹{product.regularPrice}</del>
                </small>
              </div>

              {/* 📋 Features */}
              <ul className="small text-muted text-start ps-3">
                {product?.features?.length > 0 ? (
                  product.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))
                ) : (
                  <>
                    <li>High quality service</li>
                    <li>Trusted by customers</li>
                    <li>Best value plan</li>
                  </>
                )}
              </ul>

              {/* 📦 Stock */}
              <div className="small mt-2">
                {product.stock === 0 ? (
                  <span className="text-danger">Out of stock</span>
                ) : product.stock <= 10 ? (
                  <span>Only {product.stock} left</span>
                ) : null}
              </div>

              {/* 🔗 Button */}
              <Link
                to={`/product/${myslug}`}
                className="btn btn-primary btn-sm rounded-pill w-100 mt-3"
              >
                Buy Now
              </Link>

            </div>
          </div>
        );
      })}
</div>


  </div>
</section>


  {/* TRUSTED PARTNERS BANNER (PDF Page 3) */}
  <section className="container pb-5 d-none">
    <div className="card-soft overflow-hidden">
      <div className="row g-0 align-items-stretch">
        <div className="col-lg-6 p-4">
          <h4 className="fw-bold mb-2">
            Scientifically customized oralcare solutions
          </h4>
          <div className="fw-semibold mb-3">“Perfected by dentists”</div>
          <div className="bg-lightblue p-3 rounded-4">
            <div className="small fw-semibold">Tested for Indian Mouths</div>
            <div className="small text-muted2">
              Replace this area with icons + bullets
            </div>
          </div>
        </div>
        <div
          className="col-lg-6"
          style={{
            background:
              "linear-gradient(135deg, rgba(242,140,40,.18), rgba(11,46,74,.06))",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <div className="fw-bold text-center">Product Image Placeholder</div>
        </div>
      </div>
    </div>
  </section>
  {/* DENTAL INSIGHTS (tabs + blog cards) (PDF Page 4) */}
  <section className="container pb-50 pt-50 ">
    <div className="text-center mb-3">
      <h4 className="fw-bold mb-3 text-primary">Dental Insights</h4>
    </div>
    
    <div className="row g-3">
  {isBlogsLoading ? (
    // Skeleton loading
    Array.from({ length: 4 }).map((_, index) => (
      <div className="col-md-3" key={index}>
        <div className="card-soft border border-primary bg-primary overflow-hidden h-100">
          <div
            style={{ height: 140, background: "rgba(11,46,74,.06)" }}
            className="w-100 d-flex align-items-center justify-content-center"
          >
            <div className="skeleton-loader" style={{ width: '80%', height: '20px', background: '#ddd', borderRadius: '4px' }}></div>
          </div>
          <div className="p-3">
            <div className="skeleton-loader mb-2" style={{ height: '16px', background: '#ddd', borderRadius: '4px' }}></div>
            <div className="skeleton-loader" style={{ width: '60%', height: '14px', background: '#ddd', borderRadius: '4px' }}></div>
          </div>
        </div>
      </div>
    ))
  ) : blogs.length > 0 ? (
    blogs.map((blog, index) => (
      <Link to={`/blog/${blog.slug}`} className="col-md-3" key={blog._id || index}>
        <div
         className="card-soft border border-primary bg-primary overflow-hidden h-100" >
          <img
            src={blog?.image}
            style={{ height: 140, background: "rgba(11,46,74,.06)" }}
            className="w-100 object-fit-cover"
            alt={blog.title}
          />

          <div className="p-3">
            <div className="small fw-semibold text-white">{blog.title}</div>
            <div className="small text-muted2">
              {new Date(blog.createdAt).toLocaleDateString()} • 5 min read
            </div>
          </div>
        </div>
      </Link>
    ))
  ) : (
    <div className="col-12 text-center py-5">
      <div className="mb-3">
        <i className="fas fa-newspaper fa-3x text-muted"></i>
      </div>
      <h5 className="text-muted">No Blogs Found</h5>
      <p className="text-muted small">Check back later for the latest dental insights.</p>
    </div>
  )}
</div>

 
    <div className="text-center mt-3">
      <Link
        className="btn btn-sm btn-danger rounded-pill"
        to="/allblogs"
      
      >
        Explore More Blogs →
      </Link>
    </div>
  </section>
  {/* BRING A DENTAL CAMP + FORM (PDF Page 4) */}
  <section className="bg-cream py-5 d-none">
    <div className="container">
      <div className="card-soft p-4">
        <div className="row align-items-center g-3">
          <div className="col-lg-4">
            <div className="fw-bold">Bring a Dental Camp to Your Workplace</div>
            <div className="small text-muted2">
              Free Checkups &amp; Expert Consultations
            </div>
          </div>
          <div className="col-lg-8">
            <div className="row g-2">
              <div className="col-md-4">
                <input className="form-control" placeholder="Name" />
              </div>
              <div className="col-md-4">
                <input className="form-control" placeholder="Email" />
              </div>
              <div className="col-md-4">
                <input className="form-control" placeholder="Phone Number" />
              </div>
              <div className="col-md-4">
                <input className="form-control" placeholder="Captcha" />
              </div>
              <div className="col-md-4">
                <button className="btn btn-accent w-100">Book Now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row g-4 mt-4 align-items-center">
        <div className="col-lg-7">
          <div
            className="card-soft overflow-hidden"
            style={{
              height: 240,
              background:
                "linear-gradient(135deg, rgba(11,46,74,.10), rgba(11,46,74,.02))",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <div className="fw-bold">Handshake Image Placeholder</div>
          </div>
        </div>
        <div className="col-lg-5">
          <div className="card-soft p-4">
            <div className="fw-bold mb-2">
              Trusted by 250+ Leading Companies
            </div>
            <div className="small text-muted2 mb-3">
              Boost employee wellness with on-site dental care.
            </div>
            <div className="d-flex flex-wrap gap-3 align-items-center">
              <span className="badge text-bg-light border">Panasonic</span>
              <span className="badge text-bg-light border">Vist</span>
              <span className="badge text-bg-light border">Raja Finsery</span>
              <span className="badge text-bg-light border">Mrf</span>
              <span className="badge text-bg-light border">Ri</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* MORE THAN A CLINIC TILES (PDF Page 4) */}
  <section className="container py-5 d-none">
    <div className="text-center mb-4">
      <h4 className="fw-bold mb-1">More Than a Dental Clinic</h4>
      <div className="small text-muted2">
        Our commitment doesn’t end at treatment — it begins with connection.
      </div>
    </div>
    <div className="row g-3 justify-content-center">
      <div className="col-6 col-md-2">
        <div className="tile p-3 text-center">
          <div className="icon-chip mx-auto mb-2">🎥</div>
          <div className="small fw-semibold">Educational Videos</div>
        </div>
      </div>
      <div className="col-6 col-md-2">
        <div className="tile p-3 text-center">
          <div className="icon-chip mx-auto mb-2">🤝</div>
          <div className="small fw-semibold">CSR</div>
        </div>
      </div>
      <div className="col-6 col-md-2">
        <div className="tile p-3 text-center">
          <div className="icon-chip mx-auto mb-2">📰</div>
          <div className="small fw-semibold">News &amp; Media</div>
        </div>
      </div>
      <div className="col-6 col-md-2">
        <div className="tile p-3 text-center">
          <div className="icon-chip mx-auto mb-2">🏅</div>
          <div className="small fw-semibold">Rewards</div>
        </div>
      </div>
      <div className="col-6 col-md-2">
        <div className="tile p-3 text-center">
          <div className="icon-chip mx-auto mb-2">💼</div>
          <div className="small fw-semibold">Career</div>
        </div>
      </div>
    </div>
  </section>

  <section className=" oy-5  ">


  <h2 class="fw-bold mb-2 text-primary text-center"> Media Presence
 </h2>

<div className="container mt-4 d-flex justify-content-center">



          <Swiper
            breakpoints={{
              300: {
                slidesPerView: 3,
                spaceBetween: 10, // Set the gap between slides for window width <= 400px
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 15, // Set the gap between slides for window width <= 768px
              },
              992: {
                slidesPerView: 6,
                spaceBetween: 15, // Set the gap between slides for window width <= 992px
              },
              1200: {
                slidesPerView: 6,
                spaceBetween: 20, // Set the gap between slides for window width <= 1200px
              },
            }}
            pagination={true}
            modules={[Pagination, Navigation]}
            className="swiper-wrapper"
            
          >
            {isLayoutLoading
              ? Array.from({ length: 6 }).map((_, index) => (
                <SwiperSlide>
                  <div
                    className="skeleton w-100"
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      height: "auto",
                      aspectRatio: "1/0.4",
                    }}
                  ></div>
                </SwiperSlide>
              ))
              : layout.service_logos && (
                <>
                  {layout.service_logos.map((image, index) => (
                    <SwiperSlide
                      key={index}
                      to={image.imageUrlInput}
                      className="container my-4 py-2 d-block justify-content-center mx-auto"
                    >
                      <Link to={image.imageUrlInput}>
                        <img
                          src={image.imageInput}
                          width="100%"
                          alt="YNB Healthcare Services"
                          className="w-100"
                        />
                      </Link>
                    </SwiperSlide>
                  ))}
                </>
              )}
          </Swiper>
        </div>

</section>

  {/* FAQ (PDF Page 4) */}
  <div className='bg-light pt-50 pb-50'>

  <section className="container">
    <div className="text-center mb-4">
      <h4 className="fw-bold text-primary">Frequently Asked Questions</h4>
    </div>
 

 <div className="row g-3">
  {(() => {
    const faqLeft = layout?.faqData?.slice(0, Math.ceil(layout.faqData.length / 2));
    const faqRight = layout?.faqData?.slice(Math.ceil(layout.faqData.length / 2));

    return (
      <>
        {/* LEFT COLUMN */}
        <div className="col-lg-6">
          <div className="accordion" id="faqLeft">
            {faqLeft?.map((item, index) => (
              <div className="accordion-item" key={item.id}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target={`#left-${item.id}`}
                  >
                    {item.question}
                  </button>
                </h2>
                <div
                  id={`left-${item.id}`}
                  className="accordion-collapse collapse"
                  data-bs-parent="#faqLeft"
                >
                  <div className="accordion-body small text-muted2">
                    {item.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className="col-lg-6">
          <div className="accordion" id="faqRight">
            {faqRight?.map((item, index) => (
              <div className="accordion-item" key={item.id}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target={`#right-${item.id}`}
                  >
                    {item.question}
                  </button>
                </h2>
                <div
                  id={`right-${item.id}`}
                  className="accordion-collapse collapse"
                  data-bs-parent="#faqRight"
                >
                  <div className="accordion-body small text-muted2">
                    {item.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  })()}
</div>


  </section>
    
  </div>


              </>}




 

</main>



      <main className="page d-none">
        {/* Hero Section */}
        <div className="container mt-4 ">
          <div className="row">
            {isLayoutLoading ? (
              <>
                <div className="col-md-12 pt-4">
                  <div
                    className="skeleton w-100 "
                    style={{ 
                      maxWidth: "100% ",
                      height: "auto",
                      aspectRatio: "1376/524",
                      borderRadius: 20,
                    }}
                  />
                </div>
              </>
            ) : (
              <div className="col-md-12 pt-4">
                <img
                  src={
                    layout.slider_img !== ""
                      ? layout.slider_img
                      : "/assets/img/placeholder.png"
                  }
                  width="100%"
                  alt="YNB Healthcare Services"
                  style={{ 
                    maxWidth: "100% ",
                    height: "auto",
                    aspectRatio: "1376/524",
                    borderRadius: 20,
                    objectFit: "cover",
                  }}
                />
              </div>
            )}

            <div className="col-md-9 mt-sm-4 d-none">
              <div
                className="hero hero-swiper"
                style={{
                  width: 1400,
                  maxWidth: "100% ",
                  height: "auto",
                  aspectRatio: "1400/400",
                  borderRadius: 15,
                  overflow: "hidden",
                }}
              >
                {isLayoutLoading ? (
                  <>
                    <div
                      className="skeleton w-100"
                      style={{
                        width: 1500,
                        maxWidth: "100% ",
                        height: "auto",
                        aspectRatio: "1400/400",
                      }}
                    ></div>
                  </>
                ) : (
                  <div
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <Swiper
                      pagination={true}
                      navigation={true}
                      gap={"30"}
                      ref={swiperRefLocal}
                      autoplay={{
                        delay: 1500,
                        pauseOnMouseEnter: true,
                      }}
                      loop={true}
                      modules={[Pagination, Navigation, Autoplay]}
                      className="swiper-wrapper"
                      style={{
                        width: 1400,
                        maxWidth: "100% ",
                        height: "auto",
                        aspectRatio: "1400/400",
                        borderRadius: 15,
                        overflow: "hidden",
                      }}
                    >
                      {layout.home_slider && (
                        <>
                          {layout.home_slider.map((image, index) => (
                            <SwiperSlide key={index}>
                              <img
                                className="img-fluid w-100"
                                src={image}
                                alt="YNB Healthcare Services"
                              />
                            </SwiperSlide>
                          ))}
                        </>
                      )}
                    </Swiper>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* Hero Section */}



        <div className="container mt-4 hero-swiper ">
          <br/>
          <Swiper
            breakpoints={{
              300: {
                slidesPerView: 2,
                spaceBetween: 10, // Set the gap between slides for window width <= 400px
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 15, // Set the gap between slides for window width <= 768px
              },
              992: {
                slidesPerView: 5,
                spaceBetween: 15, // Set the gap between slides for window width <= 992px
              },
              1200: {
                slidesPerView: 5,
                spaceBetween: 20, // Set the gap between slides for window width <= 1200px
              },
            }}
            pagination={true}
            autoplay={{
              delay: 1500,
              pauseOnMouseEnter: true,
            }}
            modules={[Pagination, Navigation,Autoplay]}
            className="swiper-wrapper"
          >
            {isLayoutLoading
              ? Array.from({ length: 8 }).map((_, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="skeleton w-100"
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      height: "auto",
                      aspectRatio: "1/1",
                    }}
                  ></div>
                </SwiperSlide>
              ))
              : layout.trending_product_banner && (
                <>
                  {layout.trending_product_banner.map((image, index) => (
                    <SwiperSlide>

                      <div className="h-100">
  <div
    className="w-100"
    style={{
      borderRadius: 24,
      overflow: "hidden",
       backgroundColor: getRandomPastel(), // ✅ Random pastel per box
      boxShadow: "rgba(0, 0, 0, 0.08) 0px 12px 30px"
    }}
  >
    <div
      className="position-relative"
      style={{ borderRadius: "24px 24px 0px 0px", overflow: "hidden" }}
    >
    
      <Link to={image.imageUrlInput}>
                            <img
    src={image.imageInput}
      width="100"
      alt={image.imageTITInput}
        className="img-fluid w-100"
        style={{ objectFit: "contain", height: 260 }}
      />
                      
                        </Link>

      <div
        className="position-absolute start-0 end-0 d-flex align-items-center justify-content-between px-3 pb-3"
        style={{
          bottom: 0,
          background:
            "linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.55) 100%)"
        }}
      >
        <Link
         to={image.imageUrlInput}
          className="btn border-0 px-3 py-2"
          style={{
            borderRadius: 999,
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            fontSize: 13,
            fontWeight: 500
          }}
        >
          Know More
        </Link>
        <Link
         to={image.imageUrlInput}
          className="border-0 d-flex align-items-center justify-content-center"
          style={{
            width: 34,
            height: 34,
            borderRadius: "50%",
            backgroundColor: "rgba(255, 255, 255, 0.95)"
          }}
        >
          <span style={{ fontSize: 18 }}>➜</span>
        </Link>
      </div>
    </div>
    <div
      className="pt-3 pb-3 px-3 px-md-4 bg-white"
      style={{ borderRadius: "0px 0px 24px 24px" }}
    >
      <div className="text-start mb-1">
        {" "}
              <Link to={image.imageUrlInput}>
              
               <h5 className="mb-0 fw-bold" style={{ fontSize: 16 }}>
          {image.imageTITInput}
        </h5>
 
          </Link>

       
      </div>
    </div>
  </div>
</div>
 
                    </SwiperSlide>
                  ))}
                </>
              )}
          </Swiper>
        </div>

      

        {isLayoutLoading
          ? Array.from({ length: 1 }).map((_, index) => (
            <div className="container my-4 py-2 d-block">
              <div
                className="skeleton w-100"
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  height: "auto",
                  aspectRatio: "1/0.1",
                }}
              ></div>
            </div>
          ))
          : layout.trending_product_carousal && (
            <>
              {layout.trending_product_carousal.map((image, index) => (
                <Link
                  key={index}
                  to={image.imageUrlInput}
                  className="container my-4 py-2 d-block"
                >
                  <img
                    src={image.imageInput}
                    width="100%"
                    alt="YNB Healthcare Services"
                    className="w-100"
                  />
                </Link>
              ))}
            </>
          )}

        <div className="container my-2 mt-4 ">
          <div className="row p-0  rounded">
            {isLayoutLoading
              ? Array.from({ length: 4 }).map((_, index) => (
                <div className=" col-md-3 mb-4">
                  <div
                    className="skeleton w-100"
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      height: "auto",
                      aspectRatio: "1/0.22",
                    }}
                  ></div>
                </div>
              ))
              : layout.latest_product_banner && (
                <>
                  {layout.latest_product_banner.map((image, index) => (
                    <Link className=" col-md-3 mb-4" to={image.imageUrlInput}>
                      <div
                        className="d-flex px-3 py-3 d-flex align-items-center gap-2 rounded blurbbg"
                        style={{
                      backgroundColor: pastelColors[index % pastelColors.length], // ✅ Random pastel per box
                          height: "100%",
                        }}
                      >
                        <img
                          alt={image.imageTITInput}
                          width="40px"
                          height="40px"
                          src={image.imageInput}
                        />

                        <div className="col">
                          <h6 className="text-dark">
                            {image.imageTITInput}{" "}
                          </h6>
                          <p
                            className="fw-light text-grey p-0 m-0"
                            style={{ fontSize: 14 }}
                          >
                            {" "}
                            {image.imageParaInput}{" "}
                          </p>
                        </div>
                        <i class="ri-arrow-right-s-line h4 m-0" />
                      </div>
                    </Link>
                  ))}
                </>
              )}
          </div>
        </div>


<div className="d-none">

        <div className="container my-2 mt-4 ">
          <div className="row">
            <div className="col-12">
              <h2> Service Category</h2>
            </div>
          </div>
          <div className="row py-2   ">
            {isLayoutLoading
              ? Array.from({ length: 6 }).map((_, index) => (
                <div className="col-md-2 col-6 mb-2">
                  <div
                    className="skeleton w-100"
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      height: "auto",
                      aspectRatio: "1/1.2",
                    }}
                  ></div>
                </div>
              ))
              : layout.latest_product_carousal && (
                <>
                  {layout.latest_product_carousal.map((image, index) => (
                    <div className="col-md-2 col-6 mb-2" key={index}>
                      <div className="p-0 bg-light-blue rounded">
                        <Link className="col py-2 " to={image.imageUrlInput}>
                          <img
                            style={{
                              width: "100%",

                              objectFit: "cover",
                              aspectRatio: "1/1",
                            }}
                            alt={image.imageTITInput}
                            width="100%"
                            className="rounded"
                            src={image.imageInput}
                          />

                          <h5 className="text-center text-primary fs-lg px-2 py-2">
                            {" "}
                            {image.imageTITInput}{" "}
                          </h5>
                        </Link>
                      </div>
                    </div>
                  ))}
                </>
              )}
          </div>
        </div>

        <div className="container mt-4">
          <Swiper
            breakpoints={{
              300: {
                slidesPerView: 1,
                spaceBetween: 10, // Set the gap between slides for window width <= 400px
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 15, // Set the gap between slides for window width <= 768px
              },
              992: {
                slidesPerView: 2,
                spaceBetween: 15, // Set the gap between slides for window width <= 992px
              },
              1200: {
                slidesPerView: 2,
                spaceBetween: 20, // Set the gap between slides for window width <= 1200px
              },
            }}
            pagination={true}
            modules={[Pagination, Navigation]}
            className="swiper-wrapper"
          >
            {isLayoutLoading
              ? Array.from({ length: 3 }).map((_, index) => (
                <SwiperSlide>
                  <div
                    className="skeleton w-100"
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      height: "auto",
                      aspectRatio: "1/0.3",
                    }}
                  ></div>
                </SwiperSlide>
              ))
              : layout.service_banner_images && (
                <>
                  {layout.service_banner_images.map((image, index) => (
                    <SwiperSlide
                      key={index}
                      className="container my-4 py-2 d-block"
                    >
                      <Link to={image.imageUrlInput} className="w-100s">
                        <img
                          src={image.imageInput}
                          width="100%"
                          alt="YNB Healthcare Services"
                          className="w-100"
                        />
                      </Link>
                    </SwiperSlide>
                  ))}
                </>
              )}
          </Swiper>
        </div>

        <div className="container my-2 mt-4">
          <div className="row">
            <div className="col-md-5">
              <img
                alt="YNB Healthcare Services"
                src={layout.collection_img}
                width="100%"
                style={{ width: "100%", maxWidth: "100%", minHeight: 400 }}
              />
            </div>
            <div className="col-md-7 d-flex flex-column justify-content-center align-items-start">
              {isLayoutLoading ? (
                Array.from({ length: 1 }).map((_, index) => (
                  <div
                    className="skeleton w-100 mb-2"
                    style={{ width: "100%", maxWidth: "100%", height: 35 }}
                  ></div>
                ))
              ) : (
                <>
                  <h1> {layout.collection_heading}</h1>
                  <p>{layout.collection_paragraph}</p>
                </>
              )}
            </div>
          </div>
          <br />
        </div>

 

        
        <div className="container my-2 mt-4 ">
          <h3 className="text-center mb-4 pb-4">Our Expert Doctor Panel </h3>
          <div className="row p-0  rounded justify-content-center">
            {isLayoutLoading
              ? Array.from({ length: 4 }).map((_, index) => (
                <div className=" col-md-4 mb-4">
                  <div
                    className="skeleton w-100"
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      height: "auto",
                      aspectRatio: "1/0.22",
                    }}
                  ></div>
                </div>
              ))
              : layout.home_doctor && (
                <>
                  {layout.home_doctor.map((image, index) => (
                    <div className="col-md-4 mb-4 text-center"  >
                      <div className="rounded-4 border p-4 bg-light">
     <img
                          alt={image.imageTITInput}
                          className="w-50 mx-auto rounded-circle"
                          src={image.imageInput}
                          style={{aspectRatio:'1/1',objectFit:'cover'}}
                        />

                            <div className="col">
                          <h4 className="text-dark">
                            {image.imageTITInput}{" "}
                          </h4>
                             <h5 className="text-primary text-primary">
                            {image.imageDoc} 
                          </h5>
                          <p
                            className="fw-light text-grey p-0 m-0"
                            style={{ fontSize: 14 }}
                          >
                            {" "}
                            {image.imageParaInput}{" "}
                          </p>
                        </div>
                      
                      </div>
                  
                    </div>
                  ))}
                </>
              )}
          </div>
        </div>


        {isLayoutLoading
          ? Array.from({ length: 1 }).map((_, index) => (
            <div className="container my-4 py-2 d-block">
              <div
                className="skeleton w-100"
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  height: "auto",
                  aspectRatio: "1/0.1",
                }}
              ></div>
            </div>
          ))
          : layout.service_category_Images && (
            <>
              {layout.service_category_Images.map((image, index) => (
                <Link
                  key={index}
                  to={image.imageUrlInput}
                  className="container my-4 py-2 d-block"
                >
                  <img
                    src={image.imageInput}
                    width="100%"
                    alt="YNB Healthcare Services"
                    className="w-100"
                  />
                </Link>
              ))}
            </>
          )}

</div>


        {/* Product Cards */}
        <div className="container pt-0 pt-sm-5 d-none">
          {/* Heading */}
          <div className="d-none d-flex flex-wrap justify-content-between align-items-center pt-1 border-bottom pb-4 mb-4">
            {/* <h2 className="h3 mb-0 me-2">Trending products</h2> */}
            <div className="ms-n4">
              {/* <a
                className="btn btn-sm btn-link link-info link-hover-primary d-flex align-items-center bg-btn-new"
                href="#"
              >
                View All
                <i className="ri-arrow-right-line ms-1" />
              </a> */}
            </div>
          </div>
          {/* Heading */}
          {/* Product Cards */}
          <div className="row pt-2 mx-n2 hero-swiper hide-desk-arrow">
            {/* Product Card */}
            <Swiper
              breakpoints={{
                300: {
                  slidesPerView: 2,
                  spaceBetween: 10, // Set the gap between slides for window width <= 400px
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20, // Set the gap between slides for window width <= 768px
                },
                992: {
                  slidesPerView: 4,
                  spaceBetween: 25, // Set the gap between slides for window width <= 992px
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 20, // Set the gap between slides for window width <= 1200px
                },
              }}
              pagination={true}
              modules={[Pagination, Navigation]}
              className="swiper-wrapper"
            >
              {isProducts
                ? Array.from({ length: 7 }).map((_, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="card-1 skeleton"
                      style={{ height: 371, borderRadius: 10 }}
                    ></div>
                  </SwiperSlide>
                ))
                : layout.trending_product && (
                  <>
                    {Products.map((product, index) => {
                      const productRatings = ratings.filter(
                        (rating) => rating.productId === product._id
                      );
                      const totalRatings = productRatings.length;
                      const totalRatingValue = productRatings.reduce(
                        (acc, curr) => acc + curr.rating,
                        0
                      );
                      const averageRating =
                        totalRatings > 0
                          ? totalRatingValue / totalRatings
                          : 0;
                      const myslug = CreateSlug(product.slug);

                      return (
                        layout.trending_product.includes(product._id) && (
                          <>
                            <SwiperSlide key={index}>
                              <div className="card card-product h-100">
                                {/* Buttons */}
                                <div className="product-buttons">
                                  <button
                                    className="btn-product btn-wishlist"
                                    type="button"
                                    data-bs-toggle="button"
                                    title="Add to wishlist"
                                  >
                                    <i className="ri-heart-line" />
                                  </button>
                                  <a
                                    className="btn-product btn-compare"
                                    href="#"
                                    title="Compare product"
                                  >
                                    <i className="ri-repeat-line" />
                                  </a>
                                  <a
                                    className="btn-product btn-view"
                                    href="#modal-quick-view"
                                    data-bs-toggle="modal"
                                    title="Quick preview"
                                  >
                                    <i className="ri-eye-line" />
                                  </a>
                                </div>
                                {/* Buttons */}
                                {/* Preview Image */}
                                <Link
                                  className="card-img-top d-block overflow-hidden flex-shrink-0"
                                  to={`/product/${myslug}/${product._id}`}
                                >
                                  <img
                                    className="img-fluid"
                                    src={product.pImage}
                                    alt={`${product.title} Product Image`}
                                  />
                                </Link>
                                {/* Preview Image */}
                                <div className="card-body d-flex flex-column align-items-start flex-grow-1 rounded-bottom h-100 py-3">
                                  {/* Product Category */}

                                  {/* Product Category */}
                                  {/* Product Title */}
                                  <h3 className="product-title flex-grow-1">
                                    <Link
                                      to={`/product/${myslug}/${product._id}`}
                                    >
                                      {" "}
                                      {product.title}{" "}
                                    </Link>
                                  </h3>
                                  {/* Product Title */}
                                  {/* Star Rating */}
                                  <span
                                    className={`star-rating star-${Math.round(averageRating) * 2
                                      }`}
                                  />

                                  {/* Star Rating */}
                                  {/* Product Price */}
                                  <div className="product-price">
                                    <span className="text-danger fs-5">
                                      <b className="fw-medium">
                                        {" "}
                                        ₹{product.salePrice}{" "}
                                      </b>
                                      <del className="text-body-secondary ms-1">
                                        <small>
                                          ₹{product.regularPrice}{" "}
                                        </small>
                                      </del>
                                    </span>
                                  </div>
                                  {/* Product Price */}
                                  {/* Product Meta */}

                                  <div className="d-flex gap-2 mb-2">
                                    {product.variations.map((variation) => {
                                      if (variation.name === "Color") {
                                        return variation.value.map(
                                          (value, idx) => {
                                            const firstVisibleProduct =
                                              product.variant_products.find(
                                                (product) =>
                                                  product.Color === value &&
                                                  product.images.length !== 0
                                              );
                                            const firstImage =
                                              firstVisibleProduct?.images[0]
                                                .src;
                                            const visibleVariant =
                                              product.variant_products.find(
                                                (variant) => variant.visible
                                              );

                                            return (
                                              <button
                                                key={idx}
                                                className="border-none p-0 rounded-circle"
                                              >
                                                <img
                                                  src={firstImage}
                                                  className="rounded-circle"
                                                  title={value}
                                                  style={{
                                                    objectFit:
                                                      "cover !important",
                                                    aspectRatio: "1/1",
                                                    width: 35,
                                                  }}
                                                  onClick={(event) => {
                                                    const productImage =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".card-img-top img"
                                                        );
                                                    const visibleVariantSale =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span b"
                                                        );
                                                    const visibleVariantRegular =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span del"
                                                        );

                                                    if (visibleVariantSale) {
                                                      visibleVariantSale.innerText = `₹${firstVisibleProduct.sale_price}`;
                                                    }
                                                    if (
                                                      visibleVariantRegular
                                                    ) {
                                                      visibleVariantRegular.innerText = `₹${firstVisibleProduct.regular_price}`;
                                                    }
                                                    if (productImage) {
                                                      productImage.src =
                                                        firstImage;
                                                    }
                                                  }}
                                                  onLoad={(event) => {
                                                    const visibleVariantSale =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span b"
                                                        );
                                                    const visibleVariantRegular =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span del"
                                                        );

                                                    if (visibleVariantSale) {
                                                      visibleVariantSale.innerText = `₹${visibleVariant.sale_price}`;
                                                    }
                                                    if (
                                                      visibleVariantRegular
                                                    ) {
                                                      visibleVariantRegular.innerText = `₹${visibleVariant.regular_price}`;
                                                    }
                                                  }}
                                                />{" "}
                                              </button>
                                            );
                                          }
                                        );
                                      } else {
                                        return null; // If the name is not "Color", don't render anything
                                      }
                                    })}
                                  </div>

                                  <span className="product-meta text-body-secondary fs-xs">
                                    {" "}
                                    {product.stock === 0 ? (
                                      <span className="text-danger">
                                        Out of stock
                                      </span>
                                    ) : product.stock <= 10 ? (
                                      <span>
                                        Only {product.stock} left in stock
                                      </span>
                                    ) : (
                                      <></>
                                    )}
                                  </span>
                                  {/* Product Meta */}
                                </div>
                                {/* Product Addon */}

                                {/* Product Addon */}
                              </div>
                              {/* Product Cards */}
                            </SwiperSlide>
                          </>
                        )
                      );
                    })}
                  </>
                )}
            </Swiper>
          </div>
          {/* Product Cards */}
        </div>
        {/* Product Cards */}

        <div className="container pt-0 pt-sm-5 d-none">
          <div className="row g-3 py-0">
            {isLayoutLoading ? (
              <>
                <div
                  className="col-md-6 skeleton "
                  style={{ height: 380, borderRadius: 10 }}
                ></div>{" "}
                <div
                  className="col-md-6 skeleton "
                  style={{ height: 380, borderRadius: 10 }}
                ></div>
              </>
            ) : (
              layout.trending_product_banner && (
                <>
                  {layout.trending_product_banner.map((banner, index) => (
                    <Link
                      class="col-md-6"
                      key={index}
                      to={banner.imageUrlInput}
                    >
                      <img src={banner.imageInput} className="w-100 rounded" />
                    </Link>
                  ))}
                </>
              )
            )}
          </div>

          <div className="row mt-4 pt-2 mx-n2 hero-swiper ">
            <Swiper
              breakpoints={{
                300: {
                  slidesPerView: 2,
                  spaceBetween: 10, // Set the gap between slides for window width <= 400px
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20, // Set the gap between slides for window width <= 768px
                },
                992: {
                  slidesPerView: 4,
                  spaceBetween: 25, // Set the gap between slides for window width <= 992px
                },
                1200: {
                  slidesPerView: 5,
                  spaceBetween: 25, // Set the gap between slides for window width <= 1200px
                },
              }}
              navigation={false}
              pagination={true}
              modules={[Pagination, Navigation]}
              className="swiper-wrapper"
            >
              {isLayoutLoading
                ? Array.from({ length: 7 }).map((_, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="card-1 skeleton"
                      style={{ height: 355, borderRadius: 10 }}
                    ></div>
                  </SwiperSlide>
                ))
                : layout.trending_product_carousal && (
                  <>
                    {layout.trending_product_carousal.map(
                      (carousal, index) => (
                        <SwiperSlide key={index}>
                          <Link to={carousal.imageUrlInput}>
                            <img
                              src={carousal.imageInput}
                              className="w-100 rounded"
                            />
                          </Link>
                        </SwiperSlide>
                      )
                    )}
                  </>
                )}
            </Swiper>
          </div>
        </div>

        {/* Product Cards */}
        <div className="container pt-0 pt-sm-5 d-none">
          {/* Heading */}
          <div className="d-flex flex-wrap justify-content-between align-items-center pt-1 border-bottom pb-4 mb-4">
            <h2 className="h3 mb-0 me-2">Best Selling Products</h2>
            <div className="ms-n4">
              {/* <a
                className="btn btn-sm btn-link link-info link-hover-primary d-flex align-items-center bg-btn-new"
                href="#"
              >
                View All
                <i className="ri-arrow-right-line ms-1" />
              </a> */}
            </div>
          </div>
          {/* Heading */}
          {/* Product Cards */}

          <div className="row pt-2 mx-n2 hero-swiper hide-desk-arrow">
            {/* Product Card */}
            <Swiper
              breakpoints={{
                300: {
                  slidesPerView: 2,
                  spaceBetween: 10, // Set the gap between slides for window width <= 400px
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20, // Set the gap between slides for window width <= 768px
                },
                992: {
                  slidesPerView: 3,
                  spaceBetween: 25, // Set the gap between slides for window width <= 992px
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 25, // Set the gap between slides for window width <= 1200px
                },
              }}
              pagination={true}
              modules={[Pagination, Navigation]}
              className="swiper-wrapper"
            >
              {isProducts
                ? Array.from({ length: 7 }).map((_, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="card-1 skeleton"
                      style={{ height: 371, borderRadius: 10 }}
                    ></div>
                  </SwiperSlide>
                ))
                : layout.best_selling_laptop && (
                  <>
                    {Products.map((product, index) => {
                      const productRatings = ratings.filter(
                        (rating) => rating.productId === product._id
                      );
                      const totalRatings = productRatings.length;
                      const totalRatingValue = productRatings.reduce(
                        (acc, curr) => acc + curr.rating,
                        0
                      );
                      const averageRating =
                        totalRatings > 0
                          ? totalRatingValue / totalRatings
                          : 0;
                      const myslug = CreateSlug(product.slug);

                      return (
                        layout.best_selling_laptop.includes(product._id) && (
                          <>
                            <SwiperSlide key={index}>
                              <div className="card card-product h-100">
                                {/* Badges */}

                                {/* Badges */}
                                {/* Buttons */}
                                <div className="product-buttons">
                                  <button
                                    className="btn-product btn-wishlist"
                                    type="button"
                                    data-bs-toggle="button"
                                    title="Add to wishlist"
                                  >
                                    <i className="ri-heart-line" />
                                  </button>
                                  <a
                                    className="btn-product btn-compare"
                                    href="#"
                                    title="Compare product"
                                  >
                                    <i className="ri-repeat-line" />
                                  </a>
                                  <a
                                    className="btn-product btn-view"
                                    href="#modal-quick-view"
                                    data-bs-toggle="modal"
                                    title="Quick preview"
                                  >
                                    <i className="ri-eye-line" />
                                  </a>
                                </div>
                                {/* Buttons */}
                                {/* Preview Image */}
                                <Link
                                  className="card-img-top d-block overflow-hidden flex-shrink-0"
                                  to={`/product/${myslug}/${product._id}`}
                                >
                                  <img
                                    className="img-fluid"
                                    src={product.pImage}
                                    alt={` ${product.title} Product Image`}
                                  />
                                </Link>
                                {/* Preview Image */}
                                <div className="card-body d-flex flex-column align-items-start flex-grow-1 rounded-bottom h-100 py-3">
                                  {/* Product Category */}

                                  {/* Product Category */}
                                  {/* Product Title */}
                                  <h3 className="product-title flex-grow-1">
                                    <Link
                                      to={`/product/${myslug}/${product._id}`}
                                    >
                                      {" "}
                                      {product.title}{" "}
                                    </Link>
                                  </h3>
                                  {/* Product Title */}
                                  {/* Star Rating */}
                                  <span
                                    className={`star-rating star-${Math.round(averageRating) * 2
                                      }`}
                                  />

                                  {/* Star Rating */}
                                  {/* Product Price */}
                                  <div className="product-price">
                                    <span className="text-danger fs-5">
                                      <b className="fw-medium">
                                        {" "}
                                        ₹{product.salePrice}{" "}
                                      </b>
                                      <del className="text-body-secondary ms-1">
                                        <small>
                                          ₹{product.regularPrice}{" "}
                                        </small>
                                      </del>
                                    </span>
                                  </div>
                                  {/* Product Price */}
                                  {/* Product Meta */}

                                  <div className="d-flex gap-2 mb-2">
                                    {product.variations.map((variation) => {
                                      if (variation.name === "Color") {
                                        return variation.value.map(
                                          (value, idx) => {
                                            const firstVisibleProduct =
                                              product.variant_products.find(
                                                (product) =>
                                                  product.Color === value &&
                                                  product.images.length !== 0
                                              );
                                            const firstImage =
                                              firstVisibleProduct?.images[0]
                                                .src;
                                            const visibleVariant =
                                              product.variant_products.find(
                                                (variant) => variant.visible
                                              );

                                            return (
                                              <button
                                                key={idx}
                                                className="border-none p-0 rounded-circle"
                                              >
                                                <img
                                                  src={firstImage}
                                                  className="rounded-circle"
                                                  title={value}
                                                  style={{
                                                    objectFit:
                                                      "cover !important",
                                                    aspectRatio: "1/1",
                                                    width: 35,
                                                  }}
                                                  onClick={(event) => {
                                                    const productImage =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".card-img-top img"
                                                        );
                                                    const visibleVariantSale =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span b"
                                                        );
                                                    const visibleVariantRegular =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span del"
                                                        );

                                                    if (visibleVariantSale) {
                                                      visibleVariantSale.innerText = `₹${firstVisibleProduct.sale_price}`;
                                                    }
                                                    if (
                                                      visibleVariantRegular
                                                    ) {
                                                      visibleVariantRegular.innerText = `₹${firstVisibleProduct.regular_price}`;
                                                    }
                                                    if (productImage) {
                                                      productImage.src =
                                                        firstImage;
                                                    }
                                                  }}
                                                  onLoad={(event) => {
                                                    const visibleVariantSale =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span b"
                                                        );
                                                    const visibleVariantRegular =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span del"
                                                        );

                                                    if (visibleVariantSale) {
                                                      visibleVariantSale.innerText = `₹${visibleVariant.sale_price}`;
                                                    }
                                                    if (
                                                      visibleVariantRegular
                                                    ) {
                                                      visibleVariantRegular.innerText = `₹${visibleVariant.regular_price}`;
                                                    }
                                                  }}
                                                />{" "}
                                              </button>
                                            );
                                          }
                                        );
                                      } else {
                                        return null; // If the name is not "Color", don't render anything
                                      }
                                    })}
                                  </div>

                                  <span className="product-meta text-body-secondary fs-xs">
                                    {" "}
                                    {product.stock === 0 ? (
                                      <span className="text-danger">
                                        Out of stock
                                      </span>
                                    ) : product.stock <= 10 ? (
                                      <span>
                                        Only {product.stock} left in stock
                                      </span>
                                    ) : (
                                      <></>
                                    )}
                                  </span>
                                  {/* Product Meta */}
                                </div>
                                {/* Product Addon */}

                                {/* Product Addon */}
                              </div>
                              {/* Product Cards */}
                            </SwiperSlide>
                          </>
                        )
                      );
                    })}
                  </>
                )}
            </Swiper>
          </div>

          {/* Product Cards */}
        </div>
        {/* Product Cards */}

        {/* Banner */}
        <div className="container py-4 py-lg-10 d-none">
          <div className="row">
            {isLayoutLoading ? (
              <>
                <div
                  className="col skeleton "
                  style={{ height: 380, borderRadius: 10 }}
                ></div>
              </>
            ) : (
              layout.latest_product_banner && (
                <>
                  <div className="col">
                    <div
                      className="row justify-content-between align-items-center overflow-hidden border rounded-1"
                      style={{ backgroundColor: "white" }}
                    >
                      <div className="py-4 my-2 my-md-0 py-md-5 px-4 ms-md-3 text-center text-sm-start col-md-7">
                        <h6 className="fs-xs text-accent text-uppercase mb-2">
                          Weekend Discount
                        </h6>
                        <h3 className="fw-medium mb-2">
                          {layout.collection_heading || ""}
                        </h3>
                        <p className="fs-base fw-light mb-4">
                          {layout.collection_paragraph || ""}
                        </p>
                        <Link
                          className="btn btn-primary btn-shadow"
                          to={layout.collection_url || ""}
                        >
                          Shop Now
                        </Link>
                      </div>
                      <img
                        className="col-md-4 my-4"
                        src={layout.collection_img || ""}
                        alt="Shop Converse"
                        width={"100%"}
                      />
                    </div>
                  </div>
                </>
              )
            )}
          </div>
        </div>
        {/* Banner */}

        {/* Product Cards */}
        <div className="container pt-0 pt-sm-5 d-none">
          {/* Heading */}
          <div className="d-flex flex-wrap justify-content-between align-items-center pt-1 border-bottom pb-4 mb-4">
            <h2 className="h3 mb-0 me-2">Latest products</h2>
            <div className="ms-n4">
              {/* <a
                className="btn btn-sm btn-link link-info link-hover-primary d-flex align-items-center bg-btn-new"
                href="#"
              >
                View All
                <i className="ri-arrow-right-line ms-1" />
              </a> */}
            </div>
          </div>
          {/* Heading */}
          {/* Product Cards */}

          <div className="row pt-2 mx-n2 hero-swiper hide-desk-arrow">
            {/* Product Card */}
            <Swiper
              breakpoints={{
                300: {
                  slidesPerView: 2,
                  spaceBetween: 10, // Set the gap between slides for window width <= 400px
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20, // Set the gap between slides for window width <= 768px
                },
                992: {
                  slidesPerView: 3,
                  spaceBetween: 25, // Set the gap between slides for window width <= 992px
                },
                1200: {
                  slidesPerView: 5,
                  spaceBetween: 25, // Set the gap between slides for window width <= 1200px
                },
              }}
              pagination={true}
              navigation={true}
              modules={[Pagination, Navigation]}
              className="swiper-wrapper"
            >
              {isProducts
                ? Array.from({ length: 7 }).map((_, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="card-1 skeleton"
                      style={{ height: 371, borderRadius: 10 }}
                    ></div>
                  </SwiperSlide>
                ))
                : layout.latest_product && (
                  <>
                    {Products.map((product, index) => {
                      const productRatings = ratings.filter(
                        (rating) => rating.productId === product._id
                      );
                      const totalRatings = productRatings.length;
                      const totalRatingValue = productRatings.reduce(
                        (acc, curr) => acc + curr.rating,
                        0
                      );
                      const averageRating =
                        totalRatings > 0
                          ? totalRatingValue / totalRatings
                          : 0;
                      const myslug = CreateSlug(product.slug);

                      return (
                        layout.latest_product.includes(product._id) && (
                          <>
                            <SwiperSlide key={index}>
                              <div className="card card-product h-100">
                                {/* Badges */}

                                {/* Badges */}
                                {/* Buttons */}
                                <div className="product-buttons">
                                  <button
                                    className="btn-product btn-wishlist"
                                    type="button"
                                    data-bs-toggle="button"
                                    title="Add to wishlist"
                                  >
                                    <i className="ri-heart-line" />
                                  </button>
                                  <a
                                    className="btn-product btn-compare"
                                    href="#"
                                    title="Compare product"
                                  >
                                    <i className="ri-repeat-line" />
                                  </a>
                                  <a
                                    className="btn-product btn-view"
                                    href="#modal-quick-view"
                                    data-bs-toggle="modal"
                                    title="Quick preview"
                                  >
                                    <i className="ri-eye-line" />
                                  </a>
                                </div>
                                {/* Buttons */}
                                {/* Preview Image */}
                                <Link
                                  className="card-img-top d-block overflow-hidden flex-shrink-0"
                                  to={`/product/${myslug}/${product._id}`}
                                >
                                  <img
                                    className="img-fluid"
                                    src={product.pImage}
                                    alt={` ${product.title} Product Image`}
                                  />
                                </Link>
                                {/* Preview Image */}
                                <div className="card-body d-flex flex-column align-items-start flex-grow-1 rounded-bottom h-100 py-3">
                                  {/* Product Category */}

                                  {/* Product Category */}
                                  {/* Product Title */}
                                  <h3 className="product-title flex-grow-1">
                                    <Link
                                      to={`/product/${myslug}/${product._id}`}
                                    >
                                      {" "}
                                      {product.title}{" "}
                                    </Link>
                                  </h3>
                                  {/* Product Title */}
                                  {/* Star Rating */}
                                  <span
                                    className={`star-rating star-${Math.round(averageRating) * 2
                                      }`}
                                  />

                                  {/* Star Rating */}
                                  {/* Product Price */}
                                  <div className="product-price">
                                    <span className="text-danger fs-5">
                                      <b className="fw-medium">
                                        {" "}
                                        ₹{product.salePrice}{" "}
                                      </b>
                                      <del className="text-body-secondary ms-1">
                                        <small>
                                          ₹{product.regularPrice}{" "}
                                        </small>
                                      </del>
                                    </span>
                                  </div>
                                  {/* Product Price */}
                                  {/* Product Meta */}

                                  <div className="d-flex gap-2 mb-2">
                                    {product.variations.map((variation) => {
                                      if (variation.name === "Color") {
                                        return variation.value.map(
                                          (value, idx) => {
                                            const firstVisibleProduct =
                                              product.variant_products.find(
                                                (product) =>
                                                  product.Color === value &&
                                                  product.images.length !== 0
                                              );
                                            const firstImage =
                                              firstVisibleProduct?.images[0]
                                                .src;
                                            const visibleVariant =
                                              product.variant_products.find(
                                                (variant) => variant.visible
                                              );

                                            return (
                                              <button
                                                key={idx}
                                                className="border-none p-0 rounded-circle"
                                              >
                                                <img
                                                  src={firstImage}
                                                  className="rounded-circle"
                                                  title={value}
                                                  style={{
                                                    objectFit:
                                                      "cover !important",
                                                    aspectRatio: "1/1",
                                                    width: 35,
                                                  }}
                                                  onClick={(event) => {
                                                    const productImage =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".card-img-top img"
                                                        );
                                                    const visibleVariantSale =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span b"
                                                        );
                                                    const visibleVariantRegular =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span del"
                                                        );

                                                    if (visibleVariantSale) {
                                                      visibleVariantSale.innerText = `₹${firstVisibleProduct.sale_price}`;
                                                    }
                                                    if (
                                                      visibleVariantRegular
                                                    ) {
                                                      visibleVariantRegular.innerText = `₹${firstVisibleProduct.regular_price}`;
                                                    }
                                                    if (productImage) {
                                                      productImage.src =
                                                        firstImage;
                                                    }
                                                  }}
                                                  onLoad={(event) => {
                                                    const visibleVariantSale =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span b"
                                                        );
                                                    const visibleVariantRegular =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span del"
                                                        );

                                                    if (visibleVariantSale) {
                                                      visibleVariantSale.innerText = `₹${visibleVariant.sale_price}`;
                                                    }
                                                    if (
                                                      visibleVariantRegular
                                                    ) {
                                                      visibleVariantRegular.innerText = `₹${visibleVariant.regular_price}`;
                                                    }
                                                  }}
                                                />{" "}
                                              </button>
                                            );
                                          }
                                        );
                                      } else {
                                        return null; // If the name is not "Color", don't render anything
                                      }
                                    })}
                                  </div>

                                  <span className="product-meta text-body-secondary fs-xs">
                                    {" "}
                                    {product.stock === 0 ? (
                                      <span className="text-danger">
                                        Out of stock
                                      </span>
                                    ) : product.stock <= 10 ? (
                                      <span>
                                        Only {product.stock} left in stock
                                      </span>
                                    ) : (
                                      <></>
                                    )}
                                  </span>
                                  {/* Product Meta */}
                                </div>
                                {/* Product Addon */}

                                {/* Product Addon */}
                              </div>
                              {/* Product Cards */}
                            </SwiperSlide>
                          </>
                        )
                      );
                    })}
                  </>
                )}
            </Swiper>
          </div>

          {/* Product Cards */}
        </div>
        {/* Product Cards */}

        <div className="container pt-0 pt-sm-5 d-none">
          <div className="row g-3 py-0">
            {isLayoutLoading ? (
              <>
                <div
                  className="col-md-6 skeleton "
                  style={{ height: 380, borderRadius: 10 }}
                ></div>{" "}
                <div
                  className="col-md-6 skeleton "
                  style={{ height: 380, borderRadius: 10 }}
                ></div>
              </>
            ) : (
              layout.latest_product_banner && (
                <>
                  {layout.latest_product_banner.map((banner, index) => (
                    <Link class="col-6" key={index} to={banner.imageUrlInput}>
                      <img src={banner.imageInput} className="w-100 rounded" />
                    </Link>
                  ))}
                </>
              )
            )}
          </div>

          <div className="row mt-4 pt-2 mx-n2 hero-swiper ">
            <Swiper
              breakpoints={{
                300: {
                  slidesPerView: 2,
                  spaceBetween: 10, // Set the gap between slides for window width <= 400px
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20, // Set the gap between slides for window width <= 768px
                },
                992: {
                  slidesPerView: 3,
                  spaceBetween: 25, // Set the gap between slides for window width <= 992px
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 25, // Set the gap between slides for window width <= 1200px
                },
              }}
              navigation={false}
              pagination={true}
              modules={[Pagination, Navigation]}
              className="swiper-wrapper"
            >
              {isLayoutLoading
                ? Array.from({ length: 7 }).map((_, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="card-1 skeleton"
                      style={{ height: 355, borderRadius: 10 }}
                    ></div>
                  </SwiperSlide>
                ))
                : layout.latest_product_carousal && (
                  <>
                    {layout.latest_product_carousal.map((carousal, index) => (
                      <SwiperSlide key={index}>
                        <Link to={carousal.imageUrlInput}>
                          <img
                            src={carousal.imageInput}
                            className="w-100 rounded"
                          />
                        </Link>
                      </SwiperSlide>
                    ))}
                  </>
                )}
            </Swiper>
          </div>
        </div>

        {/* Product Cards */}
        <div className="container pt-0 pt-sm-5 d-none">
          {/* Heading */}
          <div className="d-flex flex-wrap justify-content-between align-items-center pt-1 border-bottom pb-4 mb-4">
            <h2 className="h3 mb-0 me-2">New Product Arrivals</h2>
            {/* <div className="ms-n4">
              <a
                className="btn btn-sm btn-link link-info link-hover-primary d-flex align-items-center bg-btn-new"
                href="#"
              >
                View All
                <i className="ri-arrow-right-line ms-1" />
              </a>
            </div> */}
          </div>
          {/* Heading */}
          {/* Product Cards */}

          <div className="row pt-2 mx-n2 hero-swiper hide-desk-arrow">
            {/* Product Card */}
            <Swiper
              breakpoints={{
                300: {
                  slidesPerView: 2,
                  spaceBetween: 10, // Set the gap between slides for window width <= 400px
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20, // Set the gap between slides for window width <= 768px
                },
                992: {
                  slidesPerView: 3,
                  spaceBetween: 25, // Set the gap between slides for window width <= 992px
                },
                1200: {
                  slidesPerView: 5,
                  spaceBetween: 25, // Set the gap between slides for window width <= 1200px
                },
              }}
              pagination={true}
              modules={[Pagination, Navigation]}
              className="swiper-wrapper"
            >
              {isProducts
                ? Array.from({ length: 7 }).map((_, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="card-1 skeleton"
                      style={{ height: 371, borderRadius: 10 }}
                    ></div>
                  </SwiperSlide>
                ))
                : layout.best_selling_smartphone && (
                  <>
                    {Products.map((product, index) => {
                      const productRatings = ratings.filter(
                        (rating) => rating.productId === product._id
                      );
                      const totalRatings = productRatings.length;
                      const totalRatingValue = productRatings.reduce(
                        (acc, curr) => acc + curr.rating,
                        0
                      );
                      const averageRating =
                        totalRatings > 0
                          ? totalRatingValue / totalRatings
                          : 0;

                      const myslug = CreateSlug(product.slug);

                      return (
                        layout.best_selling_smartphone.includes(
                          product._id
                        ) && (
                          <>
                            <SwiperSlide key={index}>
                              <div className="card card-product h-100">
                                {/* Badges */}

                                {/* Badges */}
                                {/* Buttons */}
                                <div className="product-buttons">
                                  <button
                                    className="btn-product btn-wishlist"
                                    type="button"
                                    data-bs-toggle="button"
                                    title="Add to wishlist"
                                  >
                                    <i className="ri-heart-line" />
                                  </button>
                                  <a
                                    className="btn-product btn-compare"
                                    href="#"
                                    title="Compare product"
                                  >
                                    <i className="ri-repeat-line" />
                                  </a>
                                  <a
                                    className="btn-product btn-view"
                                    href="#modal-quick-view"
                                    data-bs-toggle="modal"
                                    title="Quick preview"
                                  >
                                    <i className="ri-eye-line" />
                                  </a>
                                </div>
                                {/* Buttons */}
                                {/* Preview Image */}
                                <Link
                                  className="card-img-top d-block overflow-hidden flex-shrink-0"
                                  to={`/product/${myslug}/${product._id}`}
                                >
                                  <img
                                    className="img-fluid"
                                    src={product.pImage}
                                    alt={` ${product.title} Product Image`}
                                  />
                                </Link>
                                {/* Preview Image */}
                                <div className="card-body d-flex flex-column align-items-start flex-grow-1 rounded-bottom h-100 py-3">
                                  {/* Product Category */}

                                  {/* Product Category */}
                                  {/* Product Title */}
                                  <h3 className="product-title flex-grow-1">
                                    <Link
                                      to={`/product/${myslug}/${product._id}`}
                                    >
                                      {" "}
                                      {product.title}{" "}
                                    </Link>
                                  </h3>
                                  {/* Product Title */}
                                  {/* Star Rating */}
                                  <span
                                    className={`star-rating star-${Math.round(averageRating) * 2
                                      }`}
                                  />

                                  {/* Star Rating */}
                                  {/* Product Price */}
                                  <div className="product-price">
                                    <span className="text-danger fs-5">
                                      <b className="fw-medium">
                                        {" "}
                                        ₹{product.salePrice}{" "}
                                      </b>
                                      <del className="text-body-secondary ms-1">
                                        <small>
                                          ₹{product.regularPrice}{" "}
                                        </small>
                                      </del>
                                    </span>
                                  </div>
                                  {/* Product Price */}
                                  {/* Product Meta */}

                                  <div className="d-flex gap-2 mb-2">
                                    {product.variations.map((variation) => {
                                      if (variation.name === "Color") {
                                        return variation.value.map(
                                          (value, idx) => {
                                            const firstVisibleProduct =
                                              product.variant_products.find(
                                                (product) =>
                                                  product.Color === value &&
                                                  product.images.length !== 0
                                              );
                                            const firstImage =
                                              firstVisibleProduct?.images[0]
                                                .src;
                                            const visibleVariant =
                                              product.variant_products.find(
                                                (variant) => variant.visible
                                              );

                                            return (
                                              <button
                                                key={idx}
                                                className="border-none p-0 rounded-circle"
                                              >
                                                <img
                                                  src={firstImage}
                                                  className="rounded-circle"
                                                  title={value}
                                                  style={{
                                                    objectFit:
                                                      "cover !important",
                                                    aspectRatio: "1/1",
                                                    width: 35,
                                                  }}
                                                  onClick={(event) => {
                                                    const productImage =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".card-img-top img"
                                                        );
                                                    const visibleVariantSale =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span b"
                                                        );
                                                    const visibleVariantRegular =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span del"
                                                        );

                                                    if (visibleVariantSale) {
                                                      visibleVariantSale.innerText = `₹${firstVisibleProduct.sale_price}`;
                                                    }
                                                    if (
                                                      visibleVariantRegular
                                                    ) {
                                                      visibleVariantRegular.innerText = `₹${firstVisibleProduct.regular_price}`;
                                                    }
                                                    if (productImage) {
                                                      productImage.src =
                                                        firstImage;
                                                    }
                                                  }}
                                                  onLoad={(event) => {
                                                    const visibleVariantSale =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span b"
                                                        );
                                                    const visibleVariantRegular =
                                                      event.target
                                                        .closest(
                                                          ".card-product"
                                                        )
                                                        .querySelector(
                                                          ".product-price span del"
                                                        );

                                                    if (visibleVariantSale) {
                                                      visibleVariantSale.innerText = `₹${visibleVariant.sale_price}`;
                                                    }
                                                    if (
                                                      visibleVariantRegular
                                                    ) {
                                                      visibleVariantRegular.innerText = `₹${visibleVariant.regular_price}`;
                                                    }
                                                  }}
                                                />{" "}
                                              </button>
                                            );
                                          }
                                        );
                                      } else {
                                        return null; // If the name is not "Color", don't render anything
                                      }
                                    })}
                                  </div>

                                  <span className="product-meta text-body-secondary fs-xs">
                                    {" "}
                                    {product.stock === 0 ? (
                                      <span className="text-danger">
                                        Out of stock
                                      </span>
                                    ) : product.stock <= 10 ? (
                                      <span>
                                        Only {product.stock} left in stock
                                      </span>
                                    ) : (
                                      <></>
                                    )}
                                  </span>
                                  {/* Product Meta */}
                                </div>
                                {/* Product Addon */}

                                {/* Product Addon */}
                              </div>
                              {/* Product Cards */}
                            </SwiperSlide>
                          </>
                        )
                      );
                    })}
                  </>
                )}
            </Swiper>
          </div>

          {/* Product Cards */}
        </div>
        {/* Product Cards */}

        {/* Brand Slider */}

        {/* <div className="barnd-logos py-4 py-lg-10">
    <div className="container">
      <div className="row">
        
        <div className="barnd-swiper">

        <Swiper     breakpoints={{
    300: {
      slidesPerView: 2,
      spaceBetween: 10,  
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,  
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 25,  
    },
    1200: {
      slidesPerView: 5,
      spaceBetween: 25,  
    },
  }} className="swiper-wrapper" >
           <SwiperSlide>
           <a className="d-block bg-white py-4 py-sm-3 px-2" href="#">
                    <img
                      className="d-block mx-auto"
                      src="/assets/front_img/shop/brands/01.png"
                      style={{ width: 165 }}
                      alt="Brand Logo"
                    />
                  </a>
           </SwiperSlide>

           <SwiperSlide>
           <a className="d-block bg-white py-4 py-sm-3 px-2" href="#">
                    <img
                      className="d-block mx-auto"
                      src="/assets/front_img/shop/brands/02.png"
                      style={{ width: 165 }}
                      alt="Brand Logo"
                    />
                  </a>
           </SwiperSlide>

           <SwiperSlide>
           <a className="d-block bg-white py-4 py-sm-3 px-2" href="#">
                    <img
                      className="d-block mx-auto"
                      src="/assets/front_img/shop/brands/03.png"
                      style={{ width: 165 }}
                      alt="Brand Logo"
                    />
                  </a>
           </SwiperSlide>

           <SwiperSlide>
           <a className="d-block bg-white py-4 py-sm-3 px-2" href="#">
                    <img
                      className="d-block mx-auto"
                      src="/assets/front_img/shop/brands/04.png"
                      style={{ width: 165 }}
                      alt="Brand Logo"
                    />
                  </a>
           </SwiperSlide>


           <SwiperSlide>
           <a className="d-block bg-white py-4 py-sm-3 px-2" href="#">
                    <img
                      className="d-block mx-auto"
                      src="/assets/front_img/shop/brands/05.png"
                      style={{ width: 165 }}
                      alt="Brand Logo"
                    />
                  </a>
           </SwiperSlide>

           <SwiperSlide>
           <a className="d-block bg-white py-4 py-sm-3 px-2" href="#">
                    <img
                      className="d-block mx-auto"
                      src="/assets/front_img/shop/brands/06.png"
                      style={{ width: 165 }}
                      alt="Brand Logo"
                    />
                  </a>
           </SwiperSlide>

           <SwiperSlide>
           <a className="d-block bg-white py-4 py-sm-3 px-2" href="#">
                    <img
                      className="d-block mx-auto"
                      src="/assets/front_img/shop/brands/07.png"
                      style={{ width: 165 }}
                      alt="Brand Logo"
                    />
                  </a>
           </SwiperSlide>


           <SwiperSlide>
           <a className="d-block bg-white py-4 py-sm-3 px-2" href="#">
                    <img
                      className="d-block mx-auto"
                      src="/assets/front_img/shop/brands/08.png"
                      style={{ width: 165 }}
                      alt="Brand Logo"
                    />
                  </a>
           </SwiperSlide>



           </Swiper >



        </div>

      </div>
    </div>
  </div> */}

        {/* Brand Slider */}

        {/* Product Widgets */}

        {/* Product Widgets */}
      </main>

      <Footer />
    </>
  );
};

export default Home;

